import { MultiInvestment } from '@mobi/betslip/types'

export const resetMultiInvestment = (multiInvestment: MultiInvestment) => ({
  ...multiInvestment,
  value: 0,
  isBonusBet: false,
  isBonusCash: false,
  bonusBetId: null,
})
